exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli.el-menu-item.list-group-item {\n  padding-left: 5px;\n}\n.el-menu-vertical-president {\n  margin: 5px;\n  word-wrap: break-word;\n  border-radius: 0px 20px;\n  border: 2px solid #7fa3bb;\n  padding: 10px;\n}\n.el-submenu {\n  border-radius: 20px;\n  overflow-wrap: break-word;\n  border: 2px solid #7fa3bb;\n  padding: 5px;\n}\n.el-submenu__title:hover {\n    background-color: \"#b3c0d1\";\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-287cb912","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/PresidentMenu.vue
// module id = cVWo
// module chunks = 1